import * as tslib_1 from "tslib";
import { SirenCache } from '@awp/http';
import { Store } from '@ngrx/store';
import { SirenResponseAction } from './state/actions';
var SirenCacheNgrx = /** @class */ (function (_super) {
    tslib_1.__extends(SirenCacheNgrx, _super);
    function SirenCacheNgrx(store) {
        var _this = _super.call(this) || this;
        _this.store = store;
        return _this;
    }
    SirenCacheNgrx.prototype.setResponse = function (key, value) {
        if (!this._isRestoring) {
            this.store.dispatch(new SirenResponseAction({ id: key, response: value }));
        }
        _super.prototype.setResponse.call(this, key, value);
    };
    return SirenCacheNgrx;
}(SirenCache));
export { SirenCacheNgrx };
